import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../Table/Table";
import DateRange from "../DateRange/DateRange";
import Topbar from "../Topbar/Topbar";
import PropertyReqFileds from "../Property/PropertyReqFileds";
import moment from "moment";
import { checkPermission } from "../../screen/redux/api/PermissionManager";

// const AcceptedOwner = ({ ownersList, pagination }) => {
const AcceptedOwner = ({
  ownersList,
  // handleCoupon,
  // deleteCoupon,
  pagination,
  // setPagination,
  setPage,
  page,
  typeview,
}) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  // const [pagination, setPagination] = useState("");
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(false);
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [fromDate, setFormDate] = useState();
  const [toDate, setToDate] = useState();
  const [activeStatus, setActiveStatus] = useState(1);

  const [owners, setOwners] = useState(ownersList);
  useEffect(() => {
    setOwners(ownersList);
  }, [ownersList]);

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Ticket ID",
        accessor: "ticket_id",
        accessorFn: (row) => row.ticket_transaction?.ticket,

        Cell: ({ value, row }) => {
          return (
            <p className="primary pointer">
              {row?.original?.ticket_transaction?.ticket || "-"}
            </p>
          );
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          const property = row.original;
          console.log("DASDL", property);
          return (
            <>
              <p className="text-nowrap">{value ? `${value} ` : "-"}</p>
              <p>
                {row.original?.owner_id ? `(${row.original?.owner_id})` : ""}
              </p>
            </>
          );
        },
      },
      {
        Header: "Property",
        accessor: "property",
        Cell: ({ row }) => {
          const property = row.original?.property;
          return (
            <>
              <p className="text-nowrap">
                {property ? `${property.name} ` : "-"}
              </p>
              <p>{property ? `(${property.code})` : ""}</p>
            </>
          );
        },
      },
      {
        Header: " Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return <p>{value || "-"}</p>;
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },
      {
        Header: " City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value || "-"}</p>;
        },
      },

      {
        Header: "Wallet Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },
      {
        Header: "Generated Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">{moment(value).format("DD/MM/YYYY")}</p>
          );
        },
      },
      {
        Header: "Requested by",
        accessor: "requested_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },
      {
        Header: "Current status",
        accessor: "admin_wallet_status",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value || "-"}</p>;
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/wallet-owner-add", {
                    state: { type: "view", userDatas: row?.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
              {/* <button
                onClick={() => {
                  navigate("/wallet-owner-add", {
                    state: { type: "edit", userDatas: row?.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={edit_icon} alt="" className=" edit-btn " />
              </button> */}
              {/* <button onClick={() => setPopup(true)} className="cust-btn ">
                 <img src={delete_icon} alt="" className=" edit-btn " />
               </button> */}
              {/* <input
                type="checkbox"
                checked={row.original.selected}
                onChange={() => handleCheckboxToggle(row?.original?.id)}
              />{" "} */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-WALLETOWNER") ? [...d, action] : d;
  }, [page]);

  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
    </div>
  );
};

export default AcceptedOwner;
